import { render, staticRenderFns } from "./UsersUpdateForm.vue?vue&type=template&id=f0234d8a&"
import script from "./UsersUpdateForm.vue?vue&type=script&lang=js&"
export * from "./UsersUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports